module.exports = __webpack_public_path__ + "img/c5201909-3.157ef8fb.jpg";